module.exports = __webpack_public_path__ + "img/1.aaa714ad.jpg";